import { Component } from '@angular/core';

@Component({
  selector: 'app-sat-admin-success-dialog',
  templateUrl: './sat-admin-success-dialog.component.html',
  styleUrls: ['./sat-admin-success-dialog.component.scss'],
  standalone: false,
})
export class SatAdminSuccessDialogComponent {}
